/* eslint-disable */
function socialWindow( url ) {
	var left   = ( screen.width - 570 ) / 2;
	var top    = ( screen.height - 570 ) / 2;
	var params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left;
	window.open( url,'NewWindow',params );
}

function setShareLinks() {
	let pageUrl = encodeURIComponent( window.location.href );
	let tweet   = encodeURIComponent( jQuery( 'meta[property="og:description"]' ).attr( 'content' ) );

	jQuery( '.c-social-share__item.facebook' ).on( 'click', function() {
		let url = 'https://www.facebook.com/sharer.php?u=' + pageUrl;
		socialWindow( url );
	});

	jQuery( '.c-social-share__item.twitter-x' ).on( 'click', function() {
		let url = 'https://twitter.com/intent/tweet?url=' + pageUrl + '&text=' + tweet;
		socialWindow( url );
	});

	jQuery( '.c-social-share__item.linkedin' ).on( 'click', function() {
		let url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + pageUrl;
		socialWindow( url );
	});
}

setShareLinks();
